import axiosInstance from "../utils/axiosInstance";

export const EmailService = () => {
    const validarEmail = async (email: string) => {
        try {
            var response = await axiosInstance.get(`/validate/email/${email}`);
            return response.data;
        } catch (error) {
            return undefined;
        }
    };

    return { validarEmail };
}